import { createFileRoute, redirect } from '@tanstack/react-router'
import { meetingTranscriptsSearchSchema } from '@/lib/meeting-transcripts-search'

/**
 * The Zoom page grew a second source (Avoma) and became "Meeting transcripts"
 * (see `../meeting-transcripts/index.tsx`). This route is kept as a redirect so
 * old links and bookmarks still land in the right place. It reads the same
 * search params as the page, so a deep link to a tab, a meeting or a filtered
 * list keeps pointing at the same thing; the new route's own guard then decides
 * whether the viewer may see it.
 */
export const Route = createFileRoute('/_app/backoffice/integrations/zoom/')({
  validateSearch: meetingTranscriptsSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/backoffice/integrations/meeting-transcripts',
      search,
      replace: true,
    })
  },
})
